import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalButton,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalIcon,
  ModalTextContainer,
} from '@bice_vida/ds-components-modal';
import BlueCheck from '@images/blue_check.png';
import Image from 'next/image';

import styles from './IconModal.module.scss';

export interface IconModalProps {
  isOpen?: boolean;
  onClose?: () => void;
  onAgree?: () => void;
  icon?: ReactElement;
  agreeButtonText?: string;
  children?: ReactElement;
}

const IconModal = ({
  isOpen = false,
  onClose,
  onAgree,
  icon,
  agreeButtonText,
  children,
}: IconModalProps): ReactElement => {
  const { t } = useTranslation();
  return (
    <Modal open={isOpen} className={styles['modal']}>
      <ModalCloseButton onClick={onClose} />
      <ModalContent>
        <ModalIcon>
          {icon ? icon : <Image src={BlueCheck} height={80} width={80} alt="blue_check" />}
        </ModalIcon>
        {children && (
          <ModalTextContainer style={{ overflowY: 'auto' }}>{children}</ModalTextContainer>
        )}
      </ModalContent>
      <ModalFooter style={{ marginTop: '0px' }}>
        <ModalButton onClick={onAgree} variant="primary">
          {agreeButtonText ? agreeButtonText : t('icon_modal.agree_button')}
        </ModalButton>
      </ModalFooter>
    </Modal>
  );
};

export default IconModal;
